import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectFilterV2Component } from "src/app/components/common/select-filter-v2/select-filter-v2.component";
import { MedicalToolSetSummaryFindAllService } from "../../service/medicalToolSetSummaryFindAll.service";
import { Order, Sort, UrlParameter } from "src/app/shared/utils/url.builder";
import { SelectElementV2 } from "src/app/components/common/select/selectElementV2";
import { MedicalToolSetSummaryModel } from "../../entity/medicalToolSetSummary.model";
import { FormGroup } from "@angular/forms";
import {MomentAdapter} from "../../../../../../../shared/utils/moment.utils";

@Component({
  selector: 'app-medical-toolset-select',
  standalone: true,
  imports: [CommonModule, SelectFilterV2Component],
  templateUrl: './medical-toolset-select.component.html',
  providers: [MedicalToolSetSummaryFindAllService]
})
export class MedicalToolSetSelectComponent implements OnChanges, OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() parentFormControlName: string;
  @Input() parameters: UrlParameter[] = [];
  @Input() sort: Sort = new Sort('validationDate', Order.ASCENDING);

  @Output() singleSelectionChangeEvent = new EventEmitter<MedicalToolSetSummaryModel>();
  @Output() elementsLoadedEvent = new EventEmitter<MedicalToolSetSummaryModel[]>();

  elements: SelectElementV2<MedicalToolSetSummaryModel>[] = [];

  constructor(public findAllService: MedicalToolSetSummaryFindAllService) {}

  ngOnInit() {
    this.refresh();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['parameters'] && changes['parameters'].firstChange) || changes['sort']) {
      this.refresh();
    }
  }

  refresh() {
    this.elements = [];
    this.findAllService.parameters = this.parameters;
    this.findAllService.sort = this.sort;
    this.findAllService.findAll().then(values => {
      if (values) {
        this.elementsLoadedEvent.emit(values);
        this.elements = values.map(value => {
          return {
            value: value.id,
            label: value.businessIdentifier + '(jusqu\'au ' + MomentAdapter.of(value.validationDate).formatDDMMYYY()  + ')',
            element: value
          };
        });
      }
    });
  }
}

